module.exports = __webpack_public_path__ + "img/william-henry-johnson.4aa66cc9.png";